import React from "react";
import { Grid, useTheme } from "@mui/material";

import SoftBox from "../../../SoftBox";
import SoftTypography from "../../../SoftTypography";
import SoftButton from "../../../SoftButton";
import ProgressiveCover from "../../../../img/progressive-tracking.jpg";
import AnchorCover from "../../../../img/anchor-tracking.svg";
import DisplayCover from "../../../../img/display-metric.svg";
import metricImageOne from "../../../../img/metricVidOne.jpg";
import metricImageTwo from "../../../../img/metricVidTwo.jpg";
// import VideoDialog from "./Dialogs/VideoDialog";
// import ExampleOfUseDialog from "./Dialogs/ExampleOfUseDialog";
// import MetricDialog from "./Dialogs/MetricDialog";

import { UseGroupKpis } from "../../../../hooks/kpi";

const ExploreTypes = ({ onMetricTypeSelect }) => {
  const groupKpis = UseGroupKpis();
  const MAX_WORKSPACE_KPI = 10;

  const theme = useTheme();
  const {
    primary: { main: primaryColor },
  } = theme.palette;

  const handleMetricClick = (metricTitle) => {
    onMetricTypeSelect(metricTitle);
  };

  const metricTypes = [
    {
      id: "progressive",
      cover: ProgressiveCover,
      metricTitle: "Progressive Metric",
      metricDescription:
        "Monitor your team's daily progress with this<br/> dynamic metric.",
      metricImage: metricImageOne,
      exampleDescription:
        "Use a progressive metric to track daily sales targets for your sales team.",
      buttonTitle: "Progressive Metric",
      videoUrl:
        "https://www.youtube.com/watch?v=mxT233EdY5c&ab_channel=AmazonWebServices",
      steps: [
        "Daily Sales Target: Set a progressive metric to track daily sales targets for your team. Each day, aim to reach a specific sales goal, and the system will automatically track your progress.",
        "Fitness Goals: Use progressive metrics to monitor your fitness journey. Set daily exercise targets or step goals, and strive to achieve them consistently.",
        "Project Milestones: For project management, establish progressive metrics to track milestone completion. Set daily or weekly targets for tasks completed or project stages reached.",
      ],
    },
    {
      id: "anchor",
      cover: AnchorCover,
      metricTitle: "Anchor Metric",
      metricImage: metricImageTwo,
      metricDescription:
        "Set and conquer one-time targets with ease with<br/> anchor metric.",
      exampleDescription:
        "Utilize an anchor metric to track the completion of a major project milestone.",
      buttonTitle: "Anchor Metric",
      videoUrl:
        "https://www.youtube.com/watch?v=a9__D53WsUs&ab_channel=AmazonWebServices",
      steps: [
        "Daily Sales Target: Set a progressive metric to track daily sales targets for your team. Each day, aim to reach a specific sales goal, and the system will automatically track your progress.",
        "Fitness Goals: Use progressive metrics to monitor your fitness journey. Set daily exercise targets or step goals, and strive to achieve them consistently.",
        "Project Milestones: For project management, establish progressive metrics to track milestone completion. Set daily or weekly targets for tasks completed or project stages reached.",
      ],
    },
    {
      id: "display",
      cover: DisplayCover,
      metricTitle: "Display Metric",
      metricImage: metricImageOne,
      metricDescription:
        "Transform raw data into visually engaging<br/> insights with this display metric.",
      exampleDescription:
        "Create a display metric to visualize website traffic and user engagement metrics.",
      buttonTitle: "Display Metric",
      videoUrl:
        "https://www.youtube.com/watch?v=RPis5mbM8c8&ab_channel=AmazonWebServices",
      steps: [
        "Daily Sales Target: Set a progressive metric to track daily sales targets for your team. Each day, aim to reach a specific sales goal, and the system will automatically track your progress.",
        "Fitness Goals: Use progressive metrics to monitor your fitness journey. Set daily exercise targets or step goals, and strive to achieve them consistently.",
        "Project Milestones: For project management, establish progressive metrics to track milestone completion. Set daily or weekly targets for tasks completed or project stages reached.",
      ],
    },
  ];

  const screenWidth = window.innerWidth;

  return (
    <SoftBox
      sx={{
        width: "100%",
        margin: "0 auto",
        marginBottom: "5rem",
        marginTop: "0.5rem",
      }}
    >
      <Grid container spacing={3} p={2}>
        {metricTypes.map((metric) => (
          <Grid item sm={12} md={6} lg={4} key={metric.id}>
            <SoftBox
              sx={{
                background: "linear-gradient(135.37deg, rgba(0, 0, 0, 0.4) 4.29%, rgba(255, 255, 255, 0.4) 95.6%), #EBECF0",
                backgroundBlendMode: "soft-light, normal",
                border: "1.43097px solid rgba(255, 255, 255, 0.4)",
                boxShadow: "-7.15487px -7.15487px 14.3097px #FAFBFF, 7.15487px 7.15487px 14.3097px rgba(166, 171, 189, 0.5)",
                borderRadius: "11.4478px",
                padding: "0.75rem",
              }}
            >
              {/* <SoftBox sx={{ width: "100%" }}>
                <img src={metric.cover} alt={metric.metricTitle} width="100%" />
              </SoftBox> */}
              <SoftBox sx={{ paddingY: "20px", paddingX: "10px" }}>
                <SoftTypography
                  variant="h3"
                  mb={0.5}
                  sx={{ fontSize: "22.26px", fontWeight: 700, color: "#000" }}
                >
                  {metric.metricTitle}
                </SoftTypography>
                <SoftTypography
                  variant="p"
                  sx={{ fontSize: screenWidth > 1280 ? "13.36px" : "10px", fontWeight: 400, color: "#000" }}
                >
                  {typeof metric.metricDescription === "string" && screenWidth > 1280
                    ? metric.metricDescription.split("<br/>").map((line, idx, arr) =>
                        <React.Fragment key={line}>
                          {line}
                          {idx < arr.length - 1 && <br />}
                        </React.Fragment>
                      )
                    : metric.metricDescription.replace(/<br\s*\/?>/gi, " ")}
                </SoftTypography>
                <SoftBox
                  sx={{
                    background: "#F9FAFB",
                    border: "1.1px solid #EAECF0",
                    padding: "15px",
                    borderRadius: "9px",
                    marginY: "2rem!important",
                  }}
                >
                  <SoftBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                  >
                    <SoftTypography
                      variant="p"
                      mb={1}
                      sx={{
                        fontWeight: 700,
                        fontSize: "11.13px",
                        lineHeight: "14px",
                        background: "linear-gradient(273.63deg, #7928CA 0%, #FF0080 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        color: "transparent",
                      }}
                    >
                      Learn More about this metric
                    </SoftTypography>
                    {/* <ExampleOfUseDialog metric={metric} /> */}
                  </SoftBox>
                  <img src={metric.metricImage} alt={metric.metricTitle} width="100%" />
                  {/* <SoftTypography
                    variant="p"
                    sx={{ fontSize: "10px", fontWeight: 400, color: "#344054" }}
                  >
                    {metric.exampleDescription}
                  </SoftTypography> */}
                </SoftBox>
                <SoftButton
                  variant="contained"
                  color="primary"
                  onClick={() => handleMetricClick(metric.metricTitle)}
                  sx={{
                     background: "#FCFCFD",
                     border: `0.899256px solid ${theme.palette.primary.main}`,
                     borderRadius: "3.59702px",
                     width: "100%",
                     color: theme.palette.primary.main,
                     fontWeight: 700,
                     fontSize: screenWidth > 1280 ? "14px" : "12px",
                     textTransform: "capitalize",
                     "&:hover": {
                        background: "#FCFCFD",
                        border: `0.899256px solid ${theme.palette.primary.main}`,
                     },
                  }}
                >
                  Create {metric.metricTitle}
                </SoftButton>
                {/* <SoftBox display="flex" justifyContent="center">
                  <VideoDialog metric={metric} />
                </SoftBox> */}
              </SoftBox>
            </SoftBox>
          </Grid>
        ))}
      </Grid>
    </SoftBox>
  );
};

export default ExploreTypes;
